import { Snippet } from '../../dataModels';

export const instructionSnippet: Snippet = {
  shiftsummaryDisplyId: '0d601885-bbf3-ec11-9147-005056b29cce',
  displayTemplateId: 'd9ccbddb-33d1-459d-8b8a-26307d965a6d',
  name: 'Instruction',
  displayName: 'Instruction',
  description: null,
  order: 10,
  type: 'Instruction',
  enableEdit: 'False',
  enableComment: false,
  maxRows: 0,
  count: 0,
  isEdited: false,
  canAddDeleteRows: false,
  configuration: {
    rowTitleKey: 'name',
    columnCount: 14,
    columns: [
      {
        id: 1,
        name: 'name',
        displayName: 'Name',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 2,
        name: 'description',
        displayName: 'Description',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 3,
        name: 'categoryDisplayName',
        displayName: 'Category',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 4,
        name: 'modeDisplayName',
        displayName: 'Mode',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 5,
        name: 'productDisplayName',
        displayName: 'Product',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 6,
        name: 'statusDisplayName',
        displayName: 'Status',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 7,
        name: 'assetDisplayName',
        displayName: 'Asset',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 8,
        name: 'isAuthorizationNeeded',
        displayName: 'Authorization  Needed',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 9,
        name: 'planStartTime',
        displayName: 'Planned Start Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 10,
        name: 'planEndTime',
        displayName: 'Planned End Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 11,
        name: 'scheduledStartTime',
        displayName: 'Scheduled Start Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 12,
        name: 'scheduledEndTime',
        displayName: 'Scheduled End Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 13,
        name: 'actualStartTime',
        displayName: 'Actual Start Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 14,
        name: 'actualEndTime',
        displayName: 'Actual End Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
    ],
    matrixCells: null,
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 0,
      rowData: [
        {
          name: 'Name 1',
          description: 'Description 1',
          categoryDisplayName: 'Category 1',
          modeDisplayName: 'Mode 1',
          productDisplayName: 'Product 1',
          statusDisplayName: 'Status 1',
          assetDisplayName: 'Asset 1',
          isAuthorizationNeeded: 'FALSE',
          planStartTime: 'Plan Start 1',
          planEndTime: 'Plan End 1',
          scheduledStartTime: 'Scheduled Start 1',
          scheduledEndTime: 'Scheduled End 1',
          actualStartTime: 'Actual Start 1',
          actualEndTime: 'Actual End 1',
        },
        {
          name: 'Name 2',
          description: 'Description 2',
          categoryDisplayName: 'Category 2',
          modeDisplayName: 'Mode 2',
          productDisplayName: 'Product 2',
          statusDisplayName: 'Status 2',
          assetDisplayName: 'Asset 2',
          isAuthorizationNeeded: 'FALSE',
          planStartTime: 'Plan Start 2',
          planEndTime: 'Plan End 2',
          scheduledStartTime: 'Scheduled Start 2',
          scheduledEndTime: 'Scheduled End 2',
          actualStartTime: 'Actual Start 2',
          actualEndTime: 'Actual End 2',
        },
      ],
    },
  ],
  groupSnippets: null,
};
